export default function BackgroundBlobs() {
  return (
    <div className="bg-blobs">
      <div className="bg-blob" />
      <div className="bg-blob" />
      <div className="bg-blob" />
      <div className="bg-blob" />
    </div>
  );
}
